import axios from "axios";
import { ssoApiUrl } from "../../shared/constants";

// The ssoApiUrl is typically http://localhost:5000/api/v1/auth/sso-login
// We need the base URL for other SSO endpoints like /logout
// const ssoBaseUrl = ssoApiUrl.split('/v1/')[0]; // http://localhost:5000/api

const ssoApi = axios.create({
  // baseURL: 'http://localhost:3002/api/v1', // Use the base URL for SSO API
  baseURL: 'https://ssodev.myskool.club/api/v1',
  timeout: 200000,
  withCredentials: true,
});

export const postSSORequest = async (url, payload = {}) => {
  const { data } = await ssoApi.post(url, payload);
  return data;
};

export default ssoApi;